import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.textbook.list');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-textbook-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.textbook.list/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
}

.textbook-wrap {
  min-height: 100%;
  background: #f5f6f8;
}`],
})
export class PageTextbookListComponent implements OnInit {
    public loading: boolean = true;
    public step: string = 'subject';       // subject → textbook → exam
    public subject: string = '';
    public subjectLabel: string = '';
    public textbookId: string = '';

    public textbooks: any[] = [];
    public pages: any[] = [];
    public selectedTextbook: any = null;

    // 중학교 먼저, 고등학교 다음
    public SUBJECTS = [
        { key: '역사1', label: '역사 1', schoolLevel: 'middle', group: '중학교' },
        { key: '역사2', label: '역사 2', schoolLevel: 'middle', group: '중학교' },
        { key: '역사', label: '역사 (통합)', schoolLevel: 'middle', group: '중학교' },
        { key: '한국사1', label: '한국사 1', schoolLevel: 'high', group: '고등학교' },
        { key: '한국사2', label: '한국사 2', schoolLevel: 'high', group: '고등학교' },
        { key: '한국사', label: '한국사 (통합)', schoolLevel: 'high', group: '고등학교' },
        { key: '세계사', label: '세계사', schoolLevel: 'high', group: '고등학교' },
        { key: '동아시아사', label: '동아시아사', schoolLevel: 'high', group: '고등학교' },
    ];

    public get middleSubjects() {
        return this.SUBJECTS.filter(s => s.group === '중학교');
    }

    public get highSubjects() {
        return this.SUBJECTS.filter(s => s.group === '고등학교');
    }

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.loading = false;
        await this.service.render();
    }

    public async selectSubject(sub: any) {
        this.subject = sub.key;
        this.subjectLabel = sub.label;
        this.step = 'textbook';
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("list", { subject: sub.key });
        if (code === 200) {
            this.textbooks = data.textbooks || [];
        }
        this.loading = false;
        await this.service.render();
    }

    public async selectTextbook(tb: any) {
        this.textbookId = tb.id;
        this.selectedTextbook = tb;
        this.step = 'exam';
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("pages", { textbook_id: tb.id });
        if (code === 200) {
            this.pages = data.pages || [];
        }
        this.loading = false;
        await this.service.render();
    }

    public startStudy(pageNum: number) {
        this.service.href(`/textbook/${this.textbookId}/${pageNum}`);
    }

    public goBack() {
        if (this.step === 'textbook') {
            this.step = 'subject';
            this.subject = '';
            this.subjectLabel = '';
            this.textbooks = [];
        } else if (this.step === 'exam') {
            this.step = 'textbook';
            this.textbookId = '';
            this.selectedTextbook = null;
            this.pages = [];
        }
    }

    public categoryLabel(cat: string): string {
        const map: any = { textbook: '교과서', teacher: '교사용', guide: '지도서' };
        return map[cat] || cat;
    }

    public categoryColor(cat: string): string {
        const map: any = { textbook: 'bg-blue-100 text-blue-700', teacher: 'bg-green-100 text-green-700', guide: 'bg-amber-100 text-amber-700' };
        return map[cat] || 'bg-gray-100 text-gray-700';
    }
}

export default PageTextbookListComponent;